export default __webpack_public_path__ + "static/media/avatar2.584d5c49.png";